<template>
	<div v-if="visible">
		<el-dialog title="申请开发票" class="order-files-dialog" ref="orderFilesDialog" :visible.sync="visible"
			:show-close="true" :close-on-click-modal="false" width="960px" destroy-on-close v-el-drag-dialog>
			<el-table ref="multipleTable" :data="shopList" style="width: 100%" height="100">

				<el-table-column property="ChannelName" label="充值方式" width="200">
				</el-table-column>
				<el-table-column property="InvoicePrice" label="发票金额">
				</el-table-column>
				<el-table-column property="aTime" label="充值时间">
				</el-table-column>
			</el-table>

			<el-button style="margin-top: 10px;margin-bottom: 10px;" type="primary" icon="el-icon-plus" size="mini"
				@click="onPlusInvoiceInfoBtnClick">开票信息</el-button>

			<div style="overflow-x: auto;width: 100%;">
				<div style="white-space: nowrap;">
					<el-card style="width: 25%;height: 100%;font-size: 12px;margin-right: 10px;	line-height: 24px;
				box-sizing: border-box;
				white-space: normal;
				overflow: hidden;
				display: inline-block;
				width: 50%;
				height: 100%;" v-for="item in invoiceList">

						<el-row type="flex" justify="flex-start" align="middle" style="margin-bottom: 10px;">
							<el-radio v-model="currentInvoice" :label="item" :key=""><br /></el-radio>
							<span class="brackets">{{ item.InvoiceType }}</span>
						</el-row>
						<el-row type="flex" justify="flex-start" align="middle">
							<span><i class="text-desc">发票抬头：</i>{{ item.CompanyName }}</span>
						</el-row>
						<el-row type="flex" justify="flex-start" align="middle">
							<span class=""><i class="text-desc">纳税人识别号：</i>{{ item.Certificate }}</span>
						</el-row>
						<el-row type="flex" justify="flex-start" align="middle">
							<span class=""><i class="text-desc">注册联系人：</i>{{ item.RegLinker }}</span>
						</el-row>
						<el-row type="flex" justify="flex-start" align="middle">
							<span class=""><i class="text-desc">注册电话号码：</i>{{ item.RegTel }}</span>
						</el-row>
						<el-row type="flex" justify="flex-start" align="middle">
							<span class=""><i class="text-desc">注册地址：</i>{{ item.RegAdd }}</span>
						</el-row>
						<el-row type="flex" justify="flex-start" align="middle">
							<span class=""><i class="text-desc">开户银行：</i>{{ item.DepositBank }}</span>
						</el-row>
						<el-row type="flex" justify="flex-start" align="middle">
							<span class=""><i class="text-desc">银行账号：</i>{{ item.BankAccount }}</span>
						</el-row>
					</el-card>
				</div>
			</div>

			<el-form ref="form" :model="form" label-width="80px" size="mini" style="width: 400px; margin-top: 20px;">
				<el-form-item label="接收手机">
					<el-input v-model="form.ReceiveTel" size="mini"></el-input>
				</el-form-item>
				<el-form-item label="接收邮箱">
					<el-input v-model="form.UserInvoiceEmail" size="mini"></el-input>
				</el-form-item>
			</el-form>

			<!-- <el-button style="margin-top: 10px;margin-bottom: 10px;" type="primary" icon="el-icon-plus" size="mini"
				@click="onPlusAddressInfoBtnClick">邮寄地址</el-button>

			<div style="overflow-x: auto;width: 100%;">
				<div style="white-space: nowrap;">
					<el-card style="width: 25%;height: 100%;font-size: 12px;margin-right: 10px;	line-height: 24px;
				box-sizing: border-box;
				white-space: normal;
				overflow: hidden;
				display: inline-block;
				width: 50%;
				height: 100%;" v-for="item in addressList">

						<el-row type="flex" justify="flex-start" align="middle" style="margin-bottom: 10px;">
							<el-radio v-model="currentAddress" :label="item" :key=""><br /></el-radio>
							<span class="brackets">{{item.Linker}}</span>
						</el-row>
						<el-row type="flex" justify="flex-start" align="middle">
							<span><i class="text-desc">联系电话:</i>{{item.LinkTel}}</span>
						</el-row>
						<el-row type="flex" justify="flex-start" align="middle">
							<span class="">
								<i class="text-desc">地址:</i>
								{{item.Province}}
								{{item.City}}
								{{item.Region}}
								{{item.Address}}
							</span>
						</el-row>
					</el-card>
				</div>
			</div> -->

			<span slot="footer" class="dialog-footer">
				<el-button size="small" icon="el-icon-check" type="primary" @click.stop.prevent="submit">提 交</el-button>
			</span>
		</el-dialog>

	</div>

</template>

<script>
import {
	GetList,
	OrderInvoiceEdit,
	Add,
	Edit,
	Del
} from "@/api/general-api"
import {
	convertToFormData
} from '@/api/request'
import EditInvoiceInfo from '@/views/individual/invoice/Edit.vue'
import EditAddressInfo from '@/views/individual/Address/Edit.vue'
import Vue from 'vue'

export default {
	name: 'ToInvoice',
	data() {
		return {
			form: {
				ReceiveTel: '',
				UserInvoiceEmail: ''
			},
			RechargeRecords: [],
			visible: false,
			invoiceOrderID: '',
			orderList: [],
			invoiceList: [],
			addressList: [],
			currentInvoice: [],
			currentAddress: [],
			totalAmount: 0,
			checkedOrders: [],
			shopList: [],
		}
	},
	created() {
		this.handleGetAccountList()
		this.handleGetAddressList()
	},
	methods: {
		Options({
			RechargeRecords = []
		}) {
			this.RechargeRecords = [...RechargeRecords]
			this.handleShopOrder()
		},
		/** 提交发票信息 */
		handlePostInvoice(data, close) {
			let fn = Add
			const postData = {
				Name: 'UserInvoice',
				data: JSON.stringify(data)
			}
			if (data.ID) {
				fn = Edit
				postData.ID = data.ID
			}
			fn(postData).then(res => {
				if (!res.success) {
					return this.$message.error('操作失败：' + res.msg)
				}
				close()
				this.handleGetAccountList()
				this.$message.success('操作成功！')
			})
		},
		/** 提交地址数据 */
		handlePostAddress(data, fn, close) {
			delete data.AddressArea
			fn(
				convertToFormData({
					Name: 'UserAddress',
					ID: data.ID,
					data: JSON.stringify(data)
				})
			).then((res) => {
				if (!res.success) {
					return this.$message.error('操作失败：' + res.msg)
				}
				close()
				this.$message.success('操作成功！')
				this.handleGetAddressList()
			})
		},
		onPlusInvoiceInfoBtnClick() {
			this.handleOpenInvoiceInfoEditWnd()
		},
		onPlusAddressInfoBtnClick() {
			this.handleOpenAddressInfoEditWnd()
		},
		/** 打开增加发票信息弹窗 */
		handleOpenInvoiceInfoEditWnd(obj) {
			const GirConstructor = Vue.extend(EditInvoiceInfo);
			const nodeObj = new GirConstructor();
			nodeObj.$mount(document.createElement("div"));
			document.body.appendChild(nodeObj.$el);
			nodeObj.Options(obj);
			nodeObj.Open((obj, close) => {
				console.log(obj, close);
				this.handlePostInvoice(obj, close)
			});
		},
		/** 打开增加地址信息弹窗 */
		handleOpenAddressInfoEditWnd() {
			const obj = {
				AddressArea: []
			}
			const GirConstructor = Vue.extend(EditAddressInfo);
			const nodeObj = new GirConstructor();
			nodeObj.$mount(document.createElement("div"));
			document.body.appendChild(nodeObj.$el);
			nodeObj.Options(obj);
			nodeObj.Open((obj, close) => {
				const [Province = "", City = "", Region = ""] = obj.AddressArea
				this.handlePostAddress({
					...obj,
					Province,
					City,
					Region
				}, Add, close)
			});
		},
		/** 初始化处理订单数据 */
		handleShopOrder() {
			let RechargeRecords = this.RechargeRecords
			let shopList = []
			// for (let i = 0; i < orders.length; i++) {
			// 	let deptId = orders[i].DeptID
			// 	let designIndex = 0
			// 	let list = shopList.filter((item, index) => {
			// 		if (item.DeptID == deptId) {
			// 			designIndex = index
			// 		}
			// 		return item.DeptID == deptId
			// 	})
			// 	if (list.length == 0) {
			// 		let json = {
			// 			ShopName: orders[i].ShopName,
			// 			DeptID: orders[i].DeptID,
			// 			UserInvoiceID: orders[i].UserInvoiceID,
			// 			UserAddressID: orders[i].UserAddressID,
			// 			InvoicePrice: orders[i].OrderAmt,
			// 			OrderNum: 1,
			// 			OrderInfo: [].concat(orders[i])
			// 		}
			// 		shopList.push(json)
			// 	} else {
			// 		shopList[designIndex].OrderNum += 1
			// 		shopList[designIndex].InvoicePrice = shopList[designIndex].InvoicePrice + orders[i].OrderAmt
			// 		shopList[designIndex].OrderInfo.push(orders[i])
			// 	}
			// }
			this.shopList = RechargeRecords
			console.log(shopList);
		},
		Open(onOkCallback) {
			this.visible = true;
			this.onOkCallback = onOkCallback
		},
		submit() {
			console.log(this.currentInvoice)
			console.log(this.currentAddress)

			if (this.currentInvoice.length == 0) {
				return this.$message.error("请选择一种发票类型")
			}

			if (!this.form.ReceiveTel) {
				return this.$message.error("请输入接收手机")
			}
			if (!this.form.UserInvoiceEmail) {
				return this.$message.error("请输入接收邮箱")
			}
			let address = this.currentAddress.Province + this.currentAddress.City + this.currentAddress.Region + this
				.currentAddress.Address

			for (let i = 0; i < this.shopList.length; i++) {
				this.shopList[i].InvoiceType = this.currentInvoice.InvoiceType
				this.shopList[i].CompanyName = this.currentInvoice.CompanyName
				this.shopList[i].Certificate = this.currentInvoice.Certificate
				this.shopList[i].RegAdd = this.currentInvoice.RegAdd
				this.shopList[i].DepositBank = this.currentInvoice.DepositBank
				this.shopList[i].BankAccount = this.currentInvoice.BankAccount
				this.shopList[i].RegLinker = this.currentInvoice.RegLinker
				this.shopList[i].RegTel = this.currentInvoice.RegTel

				// this.shopList[i].ReceivePerson = this.currentAddress.Linker
				// this.shopList[i].ReceiveAdd = address
				// this.shopList[i].ReceiveTel = this.currentAddress.LinkTel

				this.shopList[i].UserInvoiceEmail = this.form.UserInvoiceEmail
				this.shopList[i].ReceiveTel = this.form.ReceiveTel
			}

			console.log(this.shopList)
			if (typeof this.onOkCallback === 'function') {
				this.onOkCallback([...this.shopList], () => this.visible = false)
			}
		},

		/** 获取发票抬头信息 */
		handleGetAccountList() {
			const param = []
			const queryParam = {
				Name: 'UserInvoice',
				currentPage: 1,
				pageSize: 999,
				searchEntity: JSON.stringify(param)
			}
			GetList(queryParam).then((res) => {
				if (res.success) {
					console.log(res.data.rows)
					this.invoiceList = res.data.rows
				}
			})
		},

		/** 获取地址信息 */
		handleGetAddressList() {
			const queryParam = {
				Name: 'UserAddress',
				currentPage: 1,
				pageSize: 999,
				orderField: 'CreateTime',
				orderType: 'descend'
			}
			GetList(queryParam).then((res) => {
				if (res.success) {
					this.addressList = res.data.rows
				} else {
					this.$message.error(res.msg)
				}
			})
		},
	}
}
</script>

<style></style>